export default __webpack_public_path__ + "static/media/pizza.bd126399.png";